export const useInputFormatter = () => {
  const email = (value) => {
    return value.toLowerCase().replace(' ', '');
  };

  return {
    email
  };
};
